<template>
    <div v-click-outside="onClickOutside">
        <div class="card addUser">
            <div class="triangle"></div>
            <div class="card-body">
                <form v-on:submit.prevent>
                    <div class="form-group row">
                    <span class="col-sm-12 col-form-label">
                         <i class="fas fa-user-plus"></i>
                        <span class="ml-3 inviteUserLabel">Invite New Users</span>
                    </span>
                    </div>
                    <dl class="card-text clearfix">
                        <dt class="cardInfo">Email:</dt>
                        <dd class="cardDescription">
                            <input type="email" class="form-control addInputField" required
                                   placeholder="Enter email to send invitation"
                                   v-model="invitationFormFields.form.email"
                                   v-bind:class="{ 'is-invalid': invitationFormFields.validation.emailInvalid }"
                                   :disabled="invitationFormFields.submitDisabled"
                            >
                        </dd>
                        <dt class="cardInfo">Title:</dt>
                        <dd class="cardDescription">
                            <input type="text" maxlength="32" class="form-control addInputField" required
                                   placeholder="e.g. Building manager"
                                   v-model="invitationFormFields.form.title"
                                   v-bind:class="{ 'is-invalid': invitationFormFields.validation.titleInvalid }"
                                   :disabled="invitationFormFields.submitDisabled"
                            >
                        </dd>
                        <dt class="cardInfo">Role:</dt>
                        <dd class="cardDescription">
                            <select class="form-control form-control-sm" name="building_role" required
                                    v-model="invitationFormFields.form.buildingRole"
                                    v-bind:class="{ 'is-invalid': invitationFormFields.validation.buildingRoleIdInvalid }"
                                    :disabled="invitationFormFields.submitDisabled"
                            >
                                <option disabled v-bind:value="{id: 0, name: '', display_name: ''}" selected>Please select role</option>
                                <option v-for="(buildingRole,index) in buildingRoles" :value="buildingRole">{{buildingRole.display_name}}</option>
                            </select>
                        </dd>
                    </dl>
                    <a href="javascript:void(0)" class="cancelButton" @click="$emit('close')">Cancel</a>
                    <button type="button" class="btn btn-primary float-right buildingCard-body-btn sendInvitationButton"
                            :disabled="invitationFormFields.submitDisabled || invalidEmail"
                            v-on:click="inviteUser(buildingId)">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="invitationFormFields.submitDisabled"></span>
                      Send Invitation
                    </button>
                </form>
            </div>
        </div>
        <InfoModalComponent
                v-if="dataToPassToInfoModal.showModal"
                :confirm = "dataToPassToInfoModal"
                @close="modelClose()"
        ></InfoModalComponent>
    </div>
</template>
<script>
import InfoModalComponent from '@/components/modal/InfoComponent.vue';
import Tools from '@/app-model/tools.js';
import User from '@/app-model/user.js';
import vClickOutside from 'v-click-outside'

export default {
    props: {
      buildingRoles: [Array, Object],
      buildingId : [String,Number],
      users : Array
    },
    components:{
      InfoModalComponent
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    data() {
      return {
        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        invitationFormFields: {
          form: {
            buildingRole: {
              id: 0,
              name: '',
              display_name: ''
            },
            email: '',
            title: '',
            hide: false
          },
          validation: {
            emailInvalid: false,
            titleInvalid: false,
            buildingRoleIdInvalid: false,
          },
          submitDisabled: false,
        }
      }
    },
    methods:{
      modelClose() {
        this.dataToPassToInfoModal.showModal = false;
        if (this.dataToPassToInfoModal.success) {
          this.$emit('updateUsers');
          this.$emit('close');
        }
      },
      onClickOutside () {
        this.$emit('close')
      },
      inviteUser:function (buildingId) {
        let email = this.invitationFormFields.form.email,
          title = this.invitationFormFields.form.title,
          buildingRole = this.invitationFormFields.form.buildingRole,
          validate;

        this.invitationFormFields.validation.emailInvalid = email.length < 1;
        this.invitationFormFields.validation.buildingRoleIdInvalid = buildingRole === '' || buildingRole.id < 1;

        validate = !this.invitationFormFields.validation.emailInvalid &&
          !this.invitationFormFields.validation.titleInvalid &&
          !this.invitationFormFields.validation.buildingRoleIdInvalid;

        if (!validate) {
          return;
        }

        this.invitationFormFields.submitDisabled = true;
        return this.userModel.addUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          buildingRole.id,
          {
            email,
            title
          }
        ).then(response => {
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 200:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = true;
                this.dataToPassToInfoModal.title = 'User invited';
                this.dataToPassToInfoModal.msg = 'User has been added to the building';
                break;
              case 422 :
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = response.data;
                break;
              case 410 :
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = response.data.message;
                break
            }
          }
        }).catch((e) => {
          console.error('Failed to invite user', e);
          this.dataToPassToInfoModal.showModal = true;
          this.dataToPassToInfoModal.success = false;
          this.dataToPassToInfoModal.title = 'Error';
          this.dataToPassToInfoModal.msg = 'An unexpected error occurred. Please try again later.';
        }).finally(() => this.invitationFormFields.submitDisabled = false);
      }
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      userModel: function() {
        return new User;
      },
      filterBuildingRoles () {
        return this.buildingRoles
      },
      currentUser: function() {
        return this.$store.getters.firebaseUser;
      },
      invalidEmail: function() {
        return !this.invitationFormFields.form.email || this.invitationFormFields.form.email === this.currentUser?.email;
      }
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_users.scss";
</style>